import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { helpImagesState, popupDispatcher } from '../store';
import { SvgImage } from '.';
import { tipsIcon1 } from '../../style/images';
import { helpImage } from '../util';
import { PropTypes } from 'prop-types';
import { NodeMessage } from '.';
import { CategoryItem } from '../components/categoryBrowser/CategoryItem';

const HelpImageContainer = ( { image } ) => <img className="help-image-container" src={ helpImage( image ) } alt={ image } />;

  export const loadHelpImage = (props) => {
    const { helpImages } = props;
    let currentImage = 'disclaimer_1';
    // if ( !helpImages[currentImage] ) {
    //      currentImage = this.getDefaultImage();
    //  }
    // props.setPopup( { 
      // title : displayName || filterName, 
      // component : 
      return <HelpImageContainer image={ currentImage }/> 
    // } );
  }
